import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import sweetAlert, {
sweetStatusAlert,
sweetConfirmAlert
} from "../../../components/common/SweetAlert.js";
import { examCategoryService } from "../../../service/settings/manage/exam_category.service.js";
import Spinner from "react-bootstrap/Spinner";
import "../../../components/admin/css/common.css";
import {
Table,
TableHead,
TableRow,
TableBody,
TableCell
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import config from '../../../helper/config.js';
import {customerConstants} from "../../../helper/constants.js";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const getCustomerFeatureFlag = () => {
return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
case customerConstants.EXO_CUSTOMER1:
    break;
case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
    color: "var(--maincolor-cmc)",
    backgroundColor: "#E5F5FF",
    borderColor: "transparent",
    };
    addBtnStyle = {
    color: "#fff",
    backgroundColor: "var(--maincolor-cmc)",
    borderColor: "transparent",
    };
    break;
default:
    break;
}

export default class ManageExamCategories extends Component {
constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
    showModal: false,
    examCategories: [],
    name: "",
    description: "",
    short_code: "",
    exam_category_id: "",
    modalType: false,
    search_val: "",
    isLoading: true,
    isSpinnerLoading: false,
    isModified: false,
    limit: 10, // Set the desired limit
    offset: 0, // Set the desired offset
    search_term: "",
    sort_column: "exam_category_id",
    sort_direction: "ASC",
    totalExamCategories: 10,
    currentPage: 0,
    editVisibility: true,
    addVisibility: true,
    deleteVisibility: true,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllExamCategoryData, 2000);
}

resetFormFields = () => {
    this.setState({
        name: "",
        description: "",
        short_code: "",
    });
};

componentDidMount() {
    this.fetchAllExamCategoryData();
}

createValidationsInstance() {
    this.validator = new SimpleReactValidator();
}

fetchAllExamCategoryData() {
    const { limit, offset, search_term, sort_column, sort_direction } = this.state;
    examCategoryService.getAll(limit, offset, search_term, sort_column, sort_direction)
    .then((response) => {
        if (response.success) {
        this.setState({
            examCategories: response.data.exam_categories,
            totalExamCategories: parseInt(response.data.total_count),
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching exam categories. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching exam categories. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false, isSpinnerLoading: false });
    });
}

handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllExamCategoryData();
    }
    );
};

handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
        currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
        {
            sort_column,
            sort_direction: newSortDirection,
            offset: 0, // Reset offset when changing sorting
            currentPage: 0,
            isLoading: true,
        },
        () => {
            this.fetchAllExamCategoryData();
        }
    );
};

handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage
    },
    () => {
        this.fetchAllExamCategoryData();
    }
    );
};

handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
    {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllExamCategoryData();
    }
    );
};

handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
    this.setState(
        {
        search_term,
        isLoading: true,
        offset: 0,
        currentPage: 0,
        searchError: false,
        },
        () => {
        this.debouncedHandleSearch();
        }
    );
    } else {
    this.setState({ search_term, searchError: true });
    }
};

toggleExamCategoryModal = (modalType) => {
    this.modalType = modalType;
    this.setState((prevState) => ({
     showModal: !prevState.showModal,
    }));
};

toggleUpdateExamCategoryModal = (name, description, short_code, exam_category_id, modalType) => {
    this.setState((prevState) => ({
        showModal: !prevState.showModal,
        name: name,
        description: description,
        short_code: short_code,
        exam_category_id: exam_category_id,
        modalType: modalType,
    }));
};

handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
};

handleSweetAlert = (modalType, modalVisibility) => {
    if (this.state.isModified) {
        sweetAlert().then((response) => {
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.modalType = false;
            this.setState(() => ({
            [modalVisibility]: response,
            isModified: false,
            }));
        });
    } else {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        if (modalType) this.toggleExamCategoryModal(false);
        else this.toggleUpdateExamCategoryModal();
    }
};

//Handle Edit Submit
handleEditSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const examCategoryItem = {
            name: this.state.name,
            description: this.state.description,
            short_code: this.state.short_code
        };
        const examCategoryId = this.state.exam_category_id;

        examCategoryService.updateExamCategory(examCategoryItem, examCategoryId)
            .then((response) => {
            if (response.success) {
                this.setState({ isSpinnerLoading: false });
                this.toggleExamCategoryModal();
                sweetStatusAlert(
                "Success!",
                "Exam category information updated successfully!",
                "success"
                );
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.fetchAllExamCategoryData();
            }else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert(
                "Failed!",
                "Unable to update the exam category information",
                "error"
            );
            });
    }
};

//add new Exam Category
handleSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const { name, description, short_code } = this.state;
        const newExamCategoryItem = { name: name, description: description, short_code: short_code};

        examCategoryService.addExamCategory(newExamCategoryItem)
            .then((response) => {
            if (response.success) {
                sweetStatusAlert("Success!", response.message.success, "success");
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.toggleExamCategoryModal(false);
                this.fetchAllExamCategoryData();
            } else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((err) => {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", "Unable to create new exam category", "error");
            });
    }
};

handleDeleteExamCategory = (id) => {
    sweetConfirmAlert().then(() => {
    this.setState({ isSpinnerLoading: true });
    examCategoryService.deleteExamCategory(id)
        .then((response) => {
        this.setState({ isSpinnerLoading: false });
        if (response.success) {
            sweetStatusAlert("Success!", response.message.success, "success");
            this.fetchAllExamCategoryData();
        } else {
            sweetStatusAlert("Failed!", response.message, "error");
        }
        })
        .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert("Oops!", "Error while deleting the exam category", "info");
        });
    });
};

render() {
    const {
        limit,
        examCategories,
        totalExamCategories,
        isLoading,
        currentPage,
        isSpinnerLoading,
        editVisibility,
        addVisibility,
        deleteVisibility,
    } = this.state;
    return (
    <>
        <ContentWrapper>
        <div className="row justify-content-between align-items-center py-5 mb-3">
            <div className="col-md-6 col-6">
            <h3 className="text-nowrap">Manage Exam Categories</h3>
            </div>
            <div>
            {addVisibility && (
                <Button
                    className="insert-btn"
                    variant="primary"
                    onClick={() => this.toggleExamCategoryModal(true)}
                >
                    Add Exam Category
                </Button>
            )}
            </div>
        </div>
        <div>
            <Form.Group controlId="exampleForm.ControlInput1" className="mb-2">
            <Form.Control
                type="text"
                placeholder="Search"
                onChange={this.handleSearch}
                isInvalid={this.state.searchError}
                // style={{ width: "18%" }}
                className="col-md-3 col-12"
            />
            {this.state.searchError && (
                <Form.Control.Feedback type="invalid">
                    Invalid input
                </Form.Control.Feedback>
            )}
            </Form.Group>
            {isSpinnerLoading && (
            <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isLoading ? (
            <div
                className="loading-container"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "75vw",
                    height: "90vh",
                }}
            >
                <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
                </Spinner>
            </div>
            ) : examCategories.length > 0 ? (
            <div style={{ width: "80vw", height: "90vh", overflow: "auto" }}>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("exam_category_id")}
                    >
                        No{" "}
                        {this.state.sort_column === "exam_category_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("name")}
                    >
                        Name{" "}
                        {this.state.sort_column === "name" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("description")}
                    >
                        Description{" "}
                        {this.state.sort_column === "description" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("short_code")}
                    >
                        Short Code{" "}
                        {this.state.sort_column === "short_code" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    {(editVisibility || deleteVisibility) && (
                        <TableCell className="thead">Actions</TableCell>
                    )}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {examCategories.map((examCategoryItem) => (
                    <TableRow key={examCategoryItem.exam_category_id}>
                        <TableCell className="tData">
                            {examCategoryItem.exam_category_id}
                        </TableCell>
                        <TableCell className="tData">
                            {examCategoryItem.name}
                        </TableCell>
                        <TableCell className="tData">
                            {examCategoryItem.description}
                        </TableCell>
                        <TableCell className="tData">
                            {examCategoryItem.short_code === null ? 'N/A' : examCategoryItem.short_code}
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                        <TableCell>
                            <div className="btn-group">
                            {editVisibility && (
                                <Button
                                    onClick={() =>
                                        this.toggleUpdateExamCategoryModal(
                                            examCategoryItem.name,
                                            examCategoryItem.description,
                                            examCategoryItem.short_code,
                                            examCategoryItem.exam_category_id,
                                            false
                                        )
                                    }
                                    className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                    title="Edit Details"
                                />
                            )}
                            {deleteVisibility && (
                                <Button
                                    onClick={() =>
                                        this.handleDeleteExamCategory(
                                            examCategoryItem.exam_category_id
                                        )
                                    }
                                    className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                    title="Delete"
                                />
                            )}
                            </div>
                        </TableCell>
                        )}
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
                <MaterialCustomTablePagination
                    totalCount = {totalExamCategories}
                    currentPage = {currentPage}
                    limit = {limit}
                    handlePageChange = {this.handlePageChange}
                    handleRowsPerPageChange = {this.handleRowsPerPageChange}
                    handlePageOffsetChange = {this.handlePageOffsetChange}
                    offset = {this.state.offset}
                    rowsPerPageOptions={[5, 10, 20]}
                />
            </div>
            ) : (
            <div
                className="text-center mb-5 mt-10"
                style={{ height: "90vh" }}
            >
                <label>No Exam Categories Available!</label>
            </div>
            )}
        </div>
        </ContentWrapper>

        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showModal}
            onHide={() => this.handleSweetAlert(this.modalType, "showModal")}
        >
        {this.modalType === true ? (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Create New Exam Category </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Name *</Form.Label>
                    <Form.Control
                        type="text"
                        name="name"
                        placeholder="Type name here..."
                        value={this.state.name}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "name",
                        this.state.name,
                        "required|alpha_space|max:60",
                        {
                        className: "text-danger",
                        messages: {
                            max: "The exam category name should not be greater than 60 characters.",
                            alpha_space:
                            "The exam category name must have valid characters.",
                            required: "The exam category name field is required.",
                        },
                        }
                    )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Description *</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={2} 
                        type="text"
                        name="description"
                        placeholder="Type description here..."
                        value={this.state.description}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "description",
                        this.state.description,
                        "required|max:120",
                        {
                        className: "text-danger",
                        messages: {
                            max: "The exam category description should not be greater than 120 characters.",
                            required: "The exam category description field is required.",
                        },
                        }
                    )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Short Code*</Form.Label>
                        <Form.Control
                        type="text"
                        placeholder="short_code"
                        name="short_code"
                        value={this.state.short_code}
                        onChange={this.handleChange}
                        />
                        {this.validator.message(
                        "short_code",
                        this.state.short_code,
                        "required|max:10",
                        {
                            className: "text-danger",
                            messages: {
                            required: "The short code field is required.",
                            max: "The short code should not be greater than 10 characters.",
                            },
                        }
                        )}
                    </Form.Group>
                </Row>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleSubmit}
                >
                    Save changes
                </Button>
                <Button
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        ) : (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Update Exam Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Name *</Form.Label>
                    <Form.Control
                        type="text"
                        name="name"
                        placeholder="Type name here..."
                        value={this.state.name ? this.state.name : ""}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "name",
                        this.state.name,
                        "required|alpha_space|max:60",
                        {
                        className: "text-danger",
                        messages: {
                            max: "The exam category name should not be greater than 60 characters.",
                            alpha_space:
                            "The exam category name must have valid characters.",
                            required: "The exam category name is required.",
                        },
                        }
                    )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Description *</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={2} 
                        type="text"
                        name="description"
                        placeholder="Type description here..."
                        value={this.state.description}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "description",
                        this.state.description,
                        "required|alpha_space|max:120",
                        {
                        className: "text-danger",
                        messages: {
                            max: "The exam category description should not be greater than 120 characters.",
                            alpha_space:
                            "The exam category description must have valid characters.",
                            required: "The exam category description field is required.",
                        },
                        }
                    )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Short Code*</Form.Label>
                        <Form.Control
                        type="text"
                        placeholder="short_code"
                        name="short_code"
                        value={this.state.short_code}
                        onChange={this.handleChange}
                        />
                        {this.validator.message(
                        "short_code",
                        this.state.short_code,
                        "required|max:10",
                        {
                            className: "text-danger",
                            messages: {
                            required: "The short code field is required.",
                            max: "The short code should not be greater than 10 characters.",
                            },
                        }
                        )}
                    </Form.Group>
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="modal-btn"
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleEditSubmit}
                >
                    Save changes
                </Button>
                <Button
                    className="modal-btn"
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        )}
        </Modal>
    </>
    );
}
}
